// Подпись градации улова в карточке точки.
//
// Градация — доля от эталона (P95 самой подробной ступени лестницы с n≥20,
// см. миграцию 247), а НЕ абсолютные тонны: у СДС 9.5 т — рекордные сутки, у
// МРКТ 639 т — рядовые. Одно число «320 т» без знаменателя не говорит ничего.
//
// Поэтому в карточке остаётся ОДНО слово. Раньше рядом стояли тонны и разбор
// эталона («78% от того, что берёт ЕРОФЕЙ с орудием «трал разноглубинный
// 208/485 м…» на «сельдь тихоокеанская» (n = 31)») — на карте это читалось как
// простыня, а нужны были градация и координаты (фидбек владельца 2026-08-07).
// Сами числа из API НЕ убраны: по ним оценку можно объяснить, когда спросят.
//
// Считает градацию БД (commercial_catch_graded), здесь только слова. Рядом
// живёт исследовательская `commercial_catch_ranked` со СВОИМ, более грубым
// эталоном (без орудия лова) — на ней построены зафиксированные выводы
// валидации, и сводить их к одному числу нельзя без пересчёта тех результатов.

/** Ключи слов градации. Про улов, а не про производительность. */
export const GRADE_KEY: Record<string, string> = {
  small: 'models.catchGrade.small',
  medium: 'models.catchGrade.medium',
  large: 'models.catchGrade.large',
}

export interface CatchGradeCard {
  /** Ключ подписи («Большой улов») — единственное, что показываем. */
  titleKey: string
}

interface GradeProps {
  source?: string
  grade?: string | null
}

/** Что дописать в карточку точки вылова. null — дописывать нечего.
 *
 *  Без градации карточка молчит: тонны без эталона ни о чём не говорят, а
 *  «малый» по умолчанию выдал бы отсутствие эталона за слабый улов. */
export function catchGradeCard(props: GradeProps): CatchGradeCard | null {
  if (props.source !== 'catch') return null
  const titleKey = props.grade != null ? GRADE_KEY[props.grade] : undefined
  return titleKey ? { titleKey } : null
}
